import React from "react";
import { ManageSpecificationContainer } from "../../../containers";

const ManageSpecification = (props) => {
  return <ManageSpecificationContainer />;
};

export default ManageSpecification;
